export default __webpack_public_path__ + "static/media/bg_2.6c8f2495.jpg";